<template>
  <div v-if="umsokn">
    <v-col>
      <v-row>
        <v-col>
          <h2 class="form__header">
            {{ t('lan_greidslufrest_umsokn_step5_header') }}
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <p style="margin: 0"><strong>{{ t('lan_greidslufrest_umsokn_step5_lengd') }}</strong></p>
        </v-col>

        <v-col cols="12">
          <v-radio-group
            v-model="umsokn.paymentDeadline"
            :disabled="disable"
          >
 
                <v-radio
                  :label="t('lan_greidslufrest_umsokn_step5_lengd_þrir')"
                  :value="1"
                />
                <v-radio
                  :label="t('lan_greidslufrest_umsokn_step5_lengd_fjorir')"
                  :value="2"
                />
                <v-radio
                  :label="t('lan_greidslufrest_umsokn_step5_lengd_fimm')"
                  :value="3"
                />

                <v-radio
                  :label="t('lan_greidslufrest_umsokn_step5_lengd_sex')"
                  :value="4"
                />
          </v-radio-group>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

type Umsokn = {
  paymentDeadline?: number
} & Record<string, any>

const props = defineProps<{
  umsokn: Umsokn
  disable?: boolean
}>()

const { t } = useI18n()

// alias for template ease (keeps reactivity)
const umsokn = props.umsokn
const disable = props.disable ?? false
</script>

<style scoped>
.form__header { font-weight: 700; margin-bottom: 12px; }
</style>
